@if (activeSection() === dashboardSectionId) {
  <section class="submenu">
    <div class="submenu__inner">
      <div class="submenu__header">
        <div class="submenu__title">{{ i18n.t('submenu.dashboard.title') }}</div>
      </div>

      <div class="submenu__actions">
        <button class="primary-button primary-button--compact submenu__action-button" type="button">
          <span class="submenu__button-icon fa-solid fa-clipboard-list" aria-hidden="true"></span>
          {{ i18n.t('submenu.dashboard.myAudits') }}
        </button>
      </div>
    </div>
  </section>
}

@if (activeSection() === checklistSectionId) {
  <section class="submenu">
    <div class="submenu__inner">
      <div class="submenu__header">
        <div class="submenu__title">{{ i18n.t('submenu.checklists.title') }}</div>
      </div>

      <div class="submenu__actions">
        <label class="app-field app-field--compact submenu__search-field">
          <span class="app-field__label">{{ i18n.t('submenu.checklists.searchLabel') }}</span>
          <input
            type="search"
            [placeholder]="i18n.t('submenu.checklists.searchPlaceholder')"
            [value]="checklistSearchValue()"
            (input)="updateChecklistSearchValue($any($event.target).value)"
            (keydown.enter)="submitChecklistSearch()"
          />
        </label>

        <button
          class="primary-button primary-button--compact submenu__action-button"
          type="button"
          (click)="submitChecklistSearch()"
        >
          <span class="submenu__button-icon fa-solid fa-magnifying-glass" aria-hidden="true"></span>
          {{ i18n.t('submenu.checklists.searchAction') }}
        </button>

        <button
          class="secondary-button secondary-button--compact secondary-button--indigo submenu__secondary-button"
          type="button"
          (click)="createChecklist()"
        >
          <span class="submenu__button-icon fa-solid fa-circle-plus" aria-hidden="true"></span>
          {{ i18n.t('submenu.checklists.createAction') }}
        </button>
      </div>
    </div>
  </section>
}

@if (activeSection() === auditsSectionId) {
  <section class="submenu">
    <div class="submenu__inner">
      <div class="submenu__header">
        <div class="submenu__title">{{ i18n.t('submenu.audits.title') }}</div>
      </div>

      <div class="submenu__actions submenu__actions--audits">
        <label class="app-field app-field--compact submenu__search-field">
          <span class="app-field__label">{{ i18n.t('submenu.audits.searchLabel') }}</span>
          <input
            type="search"
            [placeholder]="i18n.t('submenu.audits.searchPlaceholder')"
            [value]="auditSearchValue()"
            (input)="updateAuditSearchValue($any($event.target).value)"
            (keydown.enter)="submitAuditSearch()"
          />
        </label>

        <button
          class="primary-button primary-button--compact submenu__action-button"
          type="button"
          (click)="submitAuditSearch()"
        >
          <span class="submenu__button-icon fa-solid fa-magnifying-glass" aria-hidden="true"></span>
          {{ i18n.t('submenu.audits.searchAction') }}
        </button>

        <button
          class="secondary-button secondary-button--compact secondary-button--indigo submenu__secondary-button"
          type="button"
          (click)="createAudit()"
        >
          <span class="submenu__button-icon fa-solid fa-circle-plus" aria-hidden="true"></span>
          {{ i18n.t('submenu.audits.createAction') }}
        </button>

      </div>
    </div>
  </section>
}


@if (activeSection() === usersSectionId) {
  <section class="submenu">
    <div class="submenu__inner">
      <div class="submenu__header">
        <div class="submenu__title">{{ i18n.t('submenu.users.title') }}</div>
      </div>

      <div class="submenu__actions">
        <label class="app-field app-field--compact submenu__search-field">
          <span class="app-field__label">{{ i18n.t('submenu.users.searchLabel') }}</span>
          <input
            type="search"
            [placeholder]="i18n.t('submenu.users.searchPlaceholder')"
            [value]="userSearchValue()"
            (input)="updateUserSearchValue($any($event.target).value)"
            (keydown.enter)="submitUserSearch()"
          />
        </label>

        <button
          class="primary-button primary-button--compact submenu__action-button"
          type="button"
          (click)="submitUserSearch()"
        >
          <span class="submenu__button-icon fa-solid fa-magnifying-glass" aria-hidden="true"></span>
          {{ i18n.t('submenu.users.searchAction') }}
        </button>

        <button
          class="secondary-button secondary-button--compact secondary-button--indigo submenu__secondary-button"
          type="button"
          (click)="createUser()"
        >
          <span class="submenu__button-icon fa-solid fa-circle-plus" aria-hidden="true"></span>
          {{ i18n.t('submenu.users.createAction') }}
        </button>
      </div>
    </div>
  </section>
}

@if (activeSection() === correctiveActionsSectionId) {
  <section class="submenu">
    <div class="submenu__inner">
      <div class="submenu__header">
        <div class="submenu__title">{{ i18n.t('submenu.correctiveActions.title') }}</div>
      </div>

      <div class="submenu__actions">
        <label class="app-field app-field--compact submenu__search-field">
          <span class="app-field__label">{{ i18n.t('submenu.correctiveActions.searchLabel') }}</span>
          <input
            type="search"
            [placeholder]="i18n.t('submenu.correctiveActions.searchPlaceholder')"
            [value]="issueSearchValue()"
            (input)="updateIssueSearchValue($any($event.target).value)"
            (keydown.enter)="submitIssueSearch()"
          />
        </label>

        <button
          class="primary-button primary-button--compact submenu__action-button"
          type="button"
          (click)="submitIssueSearch()"
        >
          <span class="submenu__button-icon fa-solid fa-magnifying-glass" aria-hidden="true"></span>
          {{ i18n.t('submenu.correctiveActions.searchAction') }}
        </button>

        <button
          class="secondary-button secondary-button--compact secondary-button--indigo submenu__secondary-button"
          type="button"
          (click)="reportIssue()"
        >
          <span class="submenu__button-icon fa-solid fa-triangle-exclamation" aria-hidden="true"></span>
          {{ i18n.t('submenu.correctiveActions.reportAction') }}
        </button>
      </div>
    </div>
  </section>
}

@if (activeSection() === reportsSectionId) {
  <section class="submenu">
    <div class="submenu__inner">
      <div class="submenu__header">
        <div class="submenu__title">{{ i18n.t('submenu.reports.title') }}</div>
      </div>

      <div class="submenu__actions">
        <button
          class="primary-button primary-button--compact submenu__action-button"
          type="button"
          aria-pressed="true"
        >
          <span class="submenu__button-icon fa-solid fa-file-lines" aria-hidden="true"></span>
          {{ i18n.t('submenu.reports.auditReports') }}
        </button>
      </div>
    </div>
  </section>
}
